import { useParams, useLocation } from "react-router-dom";
import axios from "axios";
import moment from "moment";

const Api = (props) => {
    const base_link = process.env.REACT_APP_BASE_URL || "/api";
    const { id } = useParams();
    const location = useLocation();
    const userRole = location.pathname.split("/")[1];

    const request = async (endpoint, data, method, headers = {}) => {
        return new Promise(async (resolve, reject) => {
            try {
                let response;

                if (method === "POST") {
                    response = await axios.post(endpoint, data, { headers });
                }
                if (method === "GET") {
                    response = await axios.get(endpoint, data, { headers });
                }
                if (method === "DELETE") {
                    response = await axios.delete(endpoint, { headers });
                }

                resolve(response);
            } catch (err) {
                reject(err);
            }
        });
    };

    const post = (endpoint, data, headers) => {
        return request(endpoint, data, "POST", headers);
    };

    const login = (data) => {
        return post(`${base_link}/login`, data);
    };

    const forgotPassword = (data) => {
        return post(`${base_link}/login/forgot-password`, data);
    };

    const resetPassword = (data) => {
        return post(`${base_link}/login/reset-password`, data);
    };

    const getAllCompanies = async (headers) => {
        return await axios.get(`${base_link}/admin/companies/0/0`, headers);
    };
    const getCompaniesEventLogs = async (headers) => {
        return await axios.get(
            `${base_link}/admin/all_event_logs/${id}`,
            headers
        );
    };
    const getCompanyDetails = async (headers) => {
        return await axios.get(`${base_link}/admin/company/${id}`, headers);
    };
    const getAllShops = async (headers, offset = 0, limit = 0, archived = false) => {
        const query = userRole === "admin" && archived ? "?archived=true" : "";
        return await axios.get(
            `${base_link}/${userRole}/shops${
                userRole === "admin" ? `/${offset}/${limit}` : ``
            }${query}`,
            headers
        );
    };
    const getShopsEventLogs = async (headers) => {
        return await axios.get(
            `${base_link}/${userRole}/event_logs/${id}`,
            headers
        );
    };
    const getShopDetails = async (headers) => {
        return await axios.get(`${base_link}/admin/shop/${id}`, headers);
    };
    const getAllEventLogs = async (headers) => {
        return await axios.get(
            `${base_link}/${userRole}/${
                userRole === "admin" ? "event_logs" : "all_event_logs"
            }/${userRole === "admin" ? "0/0" : ""}`,
            headers
        );
    };

    const editStatus = async (id, body, headers) => {
        return await axios.put(
            `${base_link}/${userRole}/shop/${id}`,
            body,
            headers
        );
    };

    const deleteShop = async (headers) => {
        return await axios.delete(`${base_link}/admin/shop/${id}`, headers);
    };

    const editShop = async (body, headers) => {
        return await axios.put(`${base_link}/admin/shop/${id}`, body, headers);
    };

    const createShop = async (body, headers) => {
        return await axios.post(`${base_link}/admin/shop`, body, headers);
    };

    const deleteCompany = async (headers) => {
        return await axios.delete(`${base_link}/admin/company/${id}`, headers);
    };
    const editCompany = async (body, headers) => {
        return await axios.put(
            `${base_link}/admin/company/${id}`,
            body,
            headers
        );
    };
    const createCompany = async (body, headers) => {
        return await axios.post(`${base_link}/admin/company`, body, headers);
    };

    const posScript = async (id, headers, date = null, endDate = null) => {
        const params = new URLSearchParams();
        if (date && endDate) {
            params.set("start_date", moment(date).format("YYYY-MM-DD"));
            params.set("end_date", moment(endDate).format("YYYY-MM-DD"));
        } else if (date) {
            params.set("date", moment(date).format("YYYY-MM-DD"));
        }
        const query = params.toString() ? `?${params.toString()}` : "";

        return await axios.get(
            `${base_link}/${userRole}/shop/script/${id}${query}`,
            headers
        );
    };

    return {
        login,
        forgotPassword,
        resetPassword,
        getAllCompanies,
        getCompaniesEventLogs,
        getCompanyDetails,
        getAllShops,
        getShopsEventLogs,
        getShopDetails,
        getAllEventLogs,
        editStatus,
        deleteShop,
        editShop,
        createShop,
        deleteCompany,
        editCompany,
        createCompany,
        posScript,
    };
};

export default Api;
